/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <!-- Listen to before and after tab change events -->
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button
          tab="home"
          href="/hitchhiking/home"
          :disabled="isInCompleteRegister"
        >
          <ion-icon name="home"></ion-icon>
          <ion-label>{{ $t("Nav.home") }}</ion-label>
        </ion-tab-button>

        <ion-tab-button
          v-if="!!!this.$store.state.userStore.user"
          tab="help"
          href="/hitchhiking/help"
        >
          <ion-icon name="help-circle"></ion-icon>
          <ion-label>{{ $t("Nav.help") }}</ion-label>
        </ion-tab-button>

        <ion-tab-button
          v-if="!!!this.$store.state.userStore.user && !onlySSO"
          tab="register"
          href="/hitchhiking/register"
        >
          <ion-icon name="create"></ion-icon>
          <ion-label>{{ $t("Nav.register") }}</ion-label>
        </ion-tab-button>

        <ion-tab-button
          v-if="!!!this.$store.state.userStore.user"
          tab="login"
          @click="handleLogin"
        >
          <ion-icon name="person"></ion-icon>
          <ion-label>{{ $t("Nav.sign-in") }}</ion-label>
        </ion-tab-button>

        <ion-tab-button
          v-if="!!this.$store.state.userStore.user"
          tab="profile"
          href="/hitchhiking/profile"
          :disabled="isInCompleteRegister"
        >
          <ion-icon name="person"></ion-icon>
          <ion-label>{{ $t("Nav.profile") }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<style>
ion-tab-bar {
  --border: none;
}

ion-tab-button {
  --background: #f5f6fa;
  --color: var(--ion-color-primary) !important;
  --color-selected: var(--ion-color-primary) !important;
}

ion-tab-button.tab-selected {
  --background: var(--ion-color-primary) !important;
  --color: var(--ion-color-light) !important;
  --color-selected: var(--ion-color-light) !important;
}

.mc-badge {
  padding: 3px 0px 1px 0px;
  top: 4px;
}
</style>

<script>
import { isPlatform } from "@ionic/core";
import { Browser } from "@capacitor/browser";
import MArticle from "../../Carpools/Article/Article.view";
import HomeHitchHiking from "../HomeHitchHiking/HomeHitchHiking.view.vue";
import RegisterHitchHiking from "../RegisterHitchHiking/RegisterHitchHiking.view.vue";
import LoginHitchHiking from "../LoginHitchHiking/LoginHitchHiking.view.vue";
import ProfileHitchHiking from "../ProfileHitchHiking/ProfileHitchHiking.view.vue";
import { IonPage } from "@ionic/vue";

export default {
  name: "carpools",
  components: {
    IonPage,
    HomeHitchHiking,
    MArticle,
    RegisterHitchHiking,
    LoginHitchHiking,
    ProfileHitchHiking,
  },
  data() {
    return {
      isMobile: isPlatform(window.document.defaultView, "mobile"),
      onlySSO: JSON.parse(process.env.VUE_APP_ONLY_SSO),
      sso: JSON.parse(process.env.VUE_APP_SSO),
      ssoButtons: [],
    };
  },
  created() {
    if (this.sso) {
      this.$store.dispatch("sso_connections").then((res) => {
        if (res && res.length > 0 && !!process.env.VUE_APP_SSO_LOGIN_PROVIDER) {
          const providers = JSON.parse(process.env.VUE_APP_SSO_LOGIN_PROVIDER);
          if (providers && providers.length > 0) {
            this.ssoButtons = res.filter((item) =>
              providers.includes(item.ssoProvider)
            );
          } else {
            this.ssoButtons = res;
          }
        }
      });
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.userStore.user;
      },
    },
    isInCompleteRegister() {
      return this.$route.path.startsWith("/hitchhiking/completeRegister");
    },
  },
  methods: {
    handleLogin() {
      if (this.onlySSO && this.ssoButtons.length > 0) {
        this.loginSSO(this.ssoButtons[0]);
      } else {
        this.$router.push("/hitchhiking/login");
      }
    },
    loginSSO(sso) {
      let uri = sso.uri;
      if (isPlatform(window.document.defaultView, "capacitor")) {
        Browser.open({ url: uri });
      } else {
        window.open(uri, "_self");
      }
    },
  },
};
</script>
